import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useAccount, useNetwork } from 'wagmi';
import { useAppDispatch, useAppSelector } from './hooks';
import { setActiveAccount } from './state/slices/account';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { setAlertModal } from './state/slices/application';
import classes from './App.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/css/globals.css';
import AlertModal from './components/Modal';
import NavBar from './components/NavBar';
import NetworkSwitchModal from './components/NetworkSwitchModal';
import Footer from './components/Footer';

import NotFoundPage from './pages/NotFound';
import { CHAIN_ID } from './config';
import ProfilePage from './pages/Profile';
import MainPage from './pages/Main';
import Playground from './pages/Playground';

ReactGA.initialize('G-5YW1W9QWMJ');
ReactGA.send(window.location.pathname + window.location.search);

function App() {
  const { address: account } = useAccount();
  const { chain } = useNetwork();
  const chainId = chain?.id;
  const dispatch = useAppDispatch();
  const [dismissedNetworkWarning, setDismissedNetworkWarning] = useState(false);

  useEffect(() => {
    // Local account array updated
    dispatch(setActiveAccount(account));
  }, [account, dispatch]);

  // Reset dismissed state when network changes to correct network
  useEffect(() => {
    if (chainId !== undefined && Number(CHAIN_ID) === chainId) {
      setDismissedNetworkWarning(false);
    }
  }, [chainId]);

  const alertModal = useAppSelector(state => state.application.alertModal);

  // Only show network modal if connected, on wrong network, and not dismissed
  const showNetworkModal = account && chainId !== undefined && Number(CHAIN_ID) !== chainId && !dismissedNetworkWarning;

  return (
    <div className={`${classes.wrapper}`}>
      {showNetworkModal && <NetworkSwitchModal onDismiss={() => setDismissedNetworkWarning(true)} />}
      {alertModal.show && (
        <AlertModal
          title={alertModal.title}
          content={<p>{alertModal.message}</p>}
          onDismiss={() => dispatch(setAlertModal({ ...alertModal, show: false }))}
        />
      )}
      <BrowserRouter>
        <NavBar />
        <Switch>
          <Route exact path="/" component={MainPage} />
          <Route exact path="/playground" component={Playground} />
          <Route
            exact
            path="/bitstray/:id"
            render={props => <ProfilePage bitstrayId={Number(props.match.params.id)} />}
          />
          <Route component={NotFoundPage} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
